import {createReducer} from '@reduxjs/toolkit';
import {applyFilters, resetFilters} from '@src/actions/item-filters.js';
import {loadSearch} from '@src/actions/search.js';
import {
  CONFIGS,
  DEFAULT_VALUES,
  KEYS,
  findNestedObj,
} from '@src/utils/filters.ts';

export const initialState = DEFAULT_VALUES;

const filters = createReducer(initialState, builder => {
  builder.addCase(applyFilters, (state, {payload}) => ({
    ...state,
    ...payload,
  }));

  builder.addCase(loadSearch, (state, {payload: search}) => {
    const searchFilters = search.filter;
    //Loading from a saved search -- previous values should be reset
    const nextState = {...initialState};
    const rangeFilters = findNestedObj(searchFilters, 'type', 'RangeFilter');
    rangeFilters.forEach(rangeFilter => {
      const filterConfig = CONFIGS[rangeFilter.field_name];
      if (filterConfig) {
        const gtVal =
          rangeFilter.config.gte ||
          rangeFilter.config.gt ||
          filterConfig.range[0];
        const ltVal =
          rangeFilter.config.lte ||
          rangeFilter.config.lt ||
          filterConfig.range[1];
        const values = [gtVal, ltVal];

        nextState[rangeFilter.field_name] = values;
      }
    });

    const groundControl = findNestedObj(
      searchFilters,
      'field_name',
      'ground_control',
    )[0];
    nextState[KEYS.GROUND_CONTROL] =
      groundControl?.config || DEFAULT_VALUES[KEYS.GROUND_CONTROL];

    const imageQuality = findNestedObj(
      searchFilters,
      'field_name',
      'quality_category',
    )[0];
    nextState[KEYS.QUALITY_CATEGORY] =
      imageQuality?.config || DEFAULT_VALUES[KEYS.QUALITY_CATEGORY];

    return nextState;
  });

  builder.addCase(resetFilters, () => initialState);
});

export default filters;
